import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export function useGetEndUserForCompressor(frameSerialNumber: string) {
    return useQuery([`end-user-for=${frameSerialNumber}`],() => new Client().compressor_GetEndUser(frameSerialNumber))
}